<template>
    <v-autocomplete
        :items="items"
        :label="label"
        :hint="hint"
        :readonly="readonly"
        :value="value"
        :multiple="multiple"
        :rules="requiredRules"
        item-text="viewName"
        item-value="parameterName"
        @change="changeItem"
        @input="changeItem"
        clearable
        >
        <template v-slot:no-data>
          {{ $t('warnings.no_data_found') }}
        </template>
    </v-autocomplete>
</template>
<script>
import Servico from '../../services/ParameterService'
import { requiredRules } from '../../utils/rules'

export default {

  name: 'ParameterSelect',

  methods: {
    changeItem (event) {
      this.$emit('change', event)
    },

    getItems () {
      Servico.findAll()
        .then(response => {
          if (response && response.data) {
            this.items = response.data
            this.items.sort((a, b) => {
              if (a.parameterName.toLocaleLowerCase() === b.parameterName.toLocaleLowerCase()) {
                return 0
              } else if (a.parameterName.toLocaleLowerCase() > b.parameterName.toLocaleLowerCase()) {
                return 1
              }
              return -1
            })
          } else {
            this.items = []
          }

          for (const item of this.items) {
            item.viewName = `[${item.parameterName}] - ${item.parameterDescription}`
          }
        })
        .catch(error => {
          console.error(`${this.$t('warnings.error.occurred')} : ${error}`)
        })
    }
  },

  mounted () {
    this.getItems()
  },

  data: () => {
    return {
      items: []
    }
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  computed: {
    requiredRules () {
      return this.required ? requiredRules(this.value) : []
    }
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  }
}
</script>
